export const LOCALIZE_KEYS = {
  address_1: 'fieldsetting.address_1',
  address_2: 'fieldsetting.address_2',
  country_code: 'fieldsetting.country_code',
  name: 'fieldsetting.name',
  email: 'fieldsetting.email',
  mobile: 'fieldsetting.mobile',
  full_name: 'fieldsetting.full_name',
  preferred_name: 'fieldsetting.preferred_name',
  spouse_full_name: 'fieldsetting.spouse_full_name',
  company_name: 'fieldsetting.company_name',
  first_name: 'fieldsetting.first_name',
  last_name: 'fieldsetting.last_name',
  phone_number: 'fieldsetting.phone_number',
  address: 'fieldsetting.address',
  postal_code: 'fieldsetting.postal_code',
  passport: 'fieldsetting.passport',
  postcode: 'fieldsetting.postcode',
  source: 'fieldsetting.source',
  nationality_country_code: 'fieldsetting.nationality_country_code',
  date_of_birth: 'fieldsetting.date_of_birth',
  sc_origin: 'fieldsetting.sc_origin',
  sc_source: 'fieldsetting.sc_source',
  remark: 'fieldsetting.remark',
  utm_campaign: 'fieldsetting.utm_campaign',
  utm_content: 'fieldsetting.utm_content',
  utm_medium: 'fieldsetting.utm_medium',
  utm_source: 'fieldsetting.utm_source',
  utm_term: 'fieldsetting.utm_term',
  company_address: 'fieldsetting.company_address',
  company_phone: 'fieldsetting.company_phone',
  monthly_income: 'fieldsetting.monthly_income',
  occupation: 'fieldsetting.occupation',
  relation: 'fieldsetting.relation',
  consideration_stage: 'fieldsetting.consideration_stage',
  'consideration_stage-options.pending_appointment': 'fieldsetting.consideration_stage-options.pending_appointment',
  'consideration_stage-options.scheduled_appointment': 'fieldsetting.consideration_stage-options.scheduled_appointment',
  'consideration_stage-options.just_browsing': 'fieldsetting.consideration_stage-options.just_browsing',
  'consideration_stage-options.pending_booking_fee': 'fieldsetting.consideration_stage-options.pending_booking_fee',
  buyer_access_allowed: 'fieldsetting.buyer_access_allowed',
  'buyer_access_allowed-options.allowed': 'fieldsetting.buyer_access_allowed-options.allowed',
  'buyer_access_allowed-options.not_allowed': 'fieldsetting.buyer_access_allowed-options.not_allowed',
  buyer_type: 'fieldsetting.buyer_type',
  'buyer_type-options.buyer_type': 'fieldsetting.buyer_type-options.buyer_type',
  'buyer_type-options.first_time_buyer': 'fieldsetting.buyer_type-options.first_time_buyer',
  'buyer_type-options.repeat_buyer': 'fieldsetting.buyer_type-options.repeat_buyer',
  'buyer_type-options.future_buyer': 'fieldsetting.buyer_type-options.future_buyer',
  gender: 'fieldsetting.gender',
  'gender-options.male': 'fieldsetting.gender-options.male',
  'gender-options.female': 'fieldsetting.gender-options.female',
  'gender-options.not_applicable': 'fieldsetting.gender-options.not_applicable',
  marital_status: 'fieldsetting.marital_status',
  'marital_status-options.single': 'fieldsetting.marital_status-options.single',
  'marital_status-options.married': 'fieldsetting.marital_status-options.married',
  'marital_status-options.divorced': 'fieldsetting.marital_status-options.divorced',
  'marital_status-options.widowed': 'fieldsetting.marital_status-options.widowed',
  'marital_status-options.separated': 'fieldsetting.marital_status-options.separated',
  'marital_status-options.not_applicable': 'fieldsetting.marital_status-options.not_applicable',
  title: 'fieldsetting.title',
  'title-options.mr': 'fieldsetting.title-options.mr',
  'title-options.mrs': 'fieldsetting.title-options.mrs',
  'title-options.ms': 'fieldsetting.title-options.ms',
  'title-options.not_applicable': 'fieldsetting.title-options.not_applicable',
  appointment_type: 'fieldsetting.appointment_type',
  'appointment_type-options.first_visit_to_sales_gallery': 'fieldsetting.appointment_type-options.first_visit_to_sales_gallery',
  'appointment_type-options.unit_reservation': 'fieldsetting.appointment_type-options.unit_reservation',
  'appointment_type-options.spa_signing': 'fieldsetting.appointment_type-options.spa_signing',
  'appointment_type-options.la_signing': 'fieldsetting.appointment_type-options.la_signing',
  'appointment_type-options.delivery_of_vp': 'fieldsetting.appointment_type-options.delivery_of_vp',
  'appointment_type-options.others': 'fieldsetting.appointment_type-options.others',
  lost_reason: 'fieldsetting.lost_reason',
  'lost_reason-options.not_interested_pricing': 'fieldsetting.lost_reason-options.not_interested_pricing',
  'lost_reason-options.not_interested_property_type': 'fieldsetting.lost_reason-options.not_interested_property_type',
  'lost_reason-options.not_interested_location': 'fieldsetting.lost_reason-options.not_interested_location',
  'lost_reason-options.opted_for_another_project': 'fieldsetting.lost_reason-options.opted_for_another_project',
  'lost_reason-options.credit_check_not_eligible': 'fieldsetting.lost_reason-options.credit_check_not_eligible',
  'lost_reason-options.expired': 'fieldsetting.lost_reason-options.expired',
  'lost_reason-options.removed': 'fieldsetting.lost_reason-options.removed',
  'lost_reason-options.cancelled_by_developer': 'fieldsetting.lost_reason-options.cancelled_by_developer',
  religion: 'fieldsetting.religion',
  'religion-options.islam': 'fieldsetting.religion-options.islam',
  'religion-options.protestantism': 'fieldsetting.religion-options.protestantism',
  'religion-options.catholicism': 'fieldsetting.religion-options.catholicism',
  'religion-options.hinduism': 'fieldsetting.religion-options.hinduism',
  'religion-options.buddhism': 'fieldsetting.religion-options.buddhism',
  'religion-options.confucianism': 'fieldsetting.religion-options.confucianism',
  'religion-options.penghayat_kepercayaan': 'fieldsetting.religion-options.penghayat_kepercayaan',
  'religion-options.others': 'fieldsetting.religion-options.others',
};
